import { render, staticRenderFns } from "./WeChatLogin.vue?vue&type=template&id=0cdaeaca&"
import script from "./WeChatLogin.vue?vue&type=script&lang=js&"
export * from "./WeChatLogin.vue?vue&type=script&lang=js&"
import style0 from "./WeChatLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports